import { COLORS } from '../constants/radar';

/**
 * Calculate competencies status information
 * @param {Array} competencies - Array of competency objects
 * @returns {Object} - Object containing color, message, totalCompetencies, completedCompetencies, and percentage
 */
export const getCompetenciesStatus = (competencies = []) => {
  const totalCompetencies = competencies?.length || 0;
  const completedCompetencies = competencies?.filter(c => c.description?.trim())?.length || 0;
  const percentage = totalCompetencies > 0 ? (completedCompetencies / totalCompetencies) * 100 : 0;
  
  let color = COLORS.TEXT_LIGHT;
  let message = 'No competencies defined';
  
  if (totalCompetencies > 0) {
    if (percentage === 0) {
      color = '#DC2626'; // Red for no descriptions
      message = 'No descriptions provided';
    } else if (percentage < 100) {
      color = '#F59E0B'; // Amber for partial completion
      message = `${completedCompetencies} of ${totalCompetencies} defined`;
    } else {
      color = '#16A34A'; // Green for full completion
      message = 'All competencies defined';
    }
  }

  return {
    color,
    message,
    totalCompetencies,
    completedCompetencies,
    percentage,
    isComplete: percentage === 100,
    hasCompetencies: totalCompetencies > 0,
    hasDescriptions: completedCompetencies > 0
  };
}; 